import { CONTAINER } from 'common';
import React from 'react';
import { COMMON_ELEMENTS } from '../Utils';
import ImportCommonIndex from '../index';

const elements = () => {
  const cols = [
    COMMON_ELEMENTS(CONTAINER.IMPORT_MEDIA),
    {
      size: 12,
      elements: [],
    },
  ];
  return [{ cols }];
};
const ImportMediaIndex = () => {
  return (
    <ImportCommonIndex
      formElements={elements()}
      title={'Media'}
      container={CONTAINER.IMPORT_MEDIA}
    />
  );
};

export default ImportMediaIndex;
